export default __webpack_public_path__ + "static/media/onboarding_first_step.9812b53f.jpg";